// Application constants

import TIMEZONES from '../assets/externalData/timezone.json'

export const APP_CONFIG = {
    APP_NAME: 'Admin Dashboard',
    VERSION: '1.0.0',
    API_TIMEOUT: 30000,
    MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
};

export const ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    DASHBOARD: '/dashboard',
    USERS: '/users',
    SETTINGS: '/settings',
};

export const API_ENDPOINTS = {
    USERS: '/users',
    AUTH: '/auth',
    SETTINGS: '/settings',
};

export const STATUS_CODES = {
    SUCCESS: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500,
};

export const MESSAGES = {
    SUCCESS: 'Operation completed successfully',
    ERROR: 'An error occurred',
    VALIDATION_ERROR: 'Please check your input',
    NETWORK_ERROR: 'Network error. Please check your connection',
    UNAUTHORIZED: 'You are not authorized to perform this action',
};

export const VALIDATION_RULES = {
    PASSWORD_MIN_LENGTH: 8,
    USERNAME_MIN_LENGTH: 3,
    EMAIL_MAX_LENGTH: 254,
};

export const TIMEZONE_OPTIONS = TIMEZONES.map((d) => ({ label: d, value: d }));
